import React, { FC } from 'react';
import { FilterVM } from '../../../common/view-model';
import { CheckboxComponent } from '../../UI/CheckboxComponent/CheckboxComponent';
import { isCurrentUserAnonymous } from '../../../helpers/authenticationHelper';
import { showParticipationFiltersMock } from '../../../mock/showParticipationFilter';
import './ShowParticipationFilterComponent.scss';
interface IShowParticipationFilterComponentProps {
	selectedFilters?: FilterVM[];
	pendingFilters?: FilterVM[];
	setPendingFilters?: React.Dispatch<React.SetStateAction<FilterVM[]>>;
	setLockModalContent: () => void;
	registerUserClickEvent?: (eventName: string) => void;
}

export const ShowParticipationFilterComponent: FC<IShowParticipationFilterComponentProps> = ({
	selectedFilters,
	pendingFilters,
	setPendingFilters,
	setLockModalContent,
	registerUserClickEvent
}) => {
	return (
		<div className='show-participation-container'>
			{showParticipationFiltersMock.map(filter => (
				<CheckboxComponent
					key={filter.id}
					checked={selectedFilters?.some(selectedFilter => selectedFilter.id === filter.id)}
					label={filter.name}
					type={filter.type}
					parentIndex={filter.id}
					parentLength={0}
					style='primary'
					isLocked={isCurrentUserAnonymous()}
					setLockModalContent={setLockModalContent}
					registerUserClickEvent={registerUserClickEvent}
					pendingFilters={pendingFilters}
					setPendingFilters={setPendingFilters}
					isNewFilter={true}
					hideTooltip={true}
				>
					{filter.children}
				</CheckboxComponent>
			))}
		</div>
	);
};
